import { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_TEL } from "../../lib/site";

const NAV = [
  { label: "What We Buy", href: "#what-we-buy" },
  { label: "Bulk Scrap", href: "#bulk-scrap" },
  { label: "Why Scrapman's", href: "#why-scrapmans" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-b border-zinc-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src="/favicon.png" alt="Scrapman's mark" className="h-9 w-9" />
          <div className="leading-none">
            <span className="font-heading text-lg tracking-wide text-zinc-950 block">SCRAPMAN'S</span>
            <span className="text-[10px] font-bold tracking-[0.28em] text-red-700 uppercase">Metal Recycling</span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-semibold text-zinc-700 hover:text-red-700 transition-colors uppercase tracking-wide"
              data-testid={`nav-${item.href.slice(1)}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            className="hidden sm:inline-flex items-center gap-2 bg-red-700 text-white px-5 py-2.5 font-heading text-sm tracking-wider hover:bg-red-800 transition-colors"
            data-testid="header-call-cta"
          >
            <Phone className="h-4 w-4" />
            CALL FOR TODAY'S PRICE
          </a>
          <button
            className="lg:hidden p-2 text-zinc-950"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-zinc-200" data-testid="mobile-menu">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block px-6 py-4 text-sm font-bold uppercase tracking-wide text-zinc-800 border-b border-zinc-100 hover:text-red-700"
              data-testid={`mobile-nav-${item.href.slice(1)}`}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};
